var React = require('react');

function Line (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M4,54.13c289.825,0,454.726,292.033,793.522,206.016S1182.29,39.782,1416.15,12c138.94-16.506,204.88,0,247.85,0","transform":"translate(0 -0.666)","fill":"none","stroke":"#ec4f36","strokeLinecap":"round","strokeWidth":"8","strokeDasharray":"31 30"}));
}

Line.defaultProps = {"width":"1668","height":"279.333","viewBox":"0 0 1668 279.333"};

module.exports = Line;

Line.default = Line;
